export default function Motorcycle({ className, ...props }) {
  return (  
    <svg
      class={`MuiSvgIcon-root ${className}`}
      focusable="false"
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{
        marginRight: '8px',
        width: '20px',
        color: 'rgb(255, 255, 255)',
      }}
      {...props}
    >
      <path
        d="M17.5 10c-.03 0-.05.01-.08.01L13.41 6H9v2h3.59l2 2h-8.1C4.01 10 2 12.02 2 14.5 2 16.99 4.01 19 6.5 19c2.22 0 4.06-1.62 4.42-3.73L13.04 14c-.02.17-.04.33-.04.5 0 2.49 2.01 4.5 4.5 4.5s4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm-8.66 5.26C8.52 16.27 7.58 17 6.47 17c-1.38 0-2.5-1.12-2.5-2.5S5.09 12 6.47 12c1.12 0 2.05.74 2.37 1.75H6v1.5l2.84.01zM17.47 17c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
        style={{
          color: 'white',
        }}
      />
    </svg>
  )
};


